import React, { useState } from "react";
import useDirtyChecker from "../../../hooks/useDirtyChecker";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { toastSuccess } from "../../../utils/toastUtils";
import GenericActionBar from "../../../Layouts/GenericActionBar/GenericActionBar";
import Input from "../../../components/FormComponents/Input";
import CodeEditor from "../../../components/BuilderComponents/CodeEditor/CodeEditor";
import Textarea from "../../../components/FormComponents/Textarea";

const EmailTemplateEditor = ({ file, templateData, setTemplateData }) => {
  const [isSaving, setIsSaving] = useState(false);
  const { isDirty, markClean } = useDirtyChecker(templateData);

  const handleChange = (e) => {
    setTemplateData({ ...templateData, [e.target.name]: e.target.value });
  };

  const handleSaveTemplate = async () => {
    try {
      setIsSaving(true);

      const payload = {
        ...templateData,
        name: file.name
      };

      const res = await axiosInstance.patch(`/email/${file.id}`, payload);
      toastSuccess(res?.message || "Template saved successfully.");
      markClean();
    } catch (err) {
      handleApiError(err);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="d_flex flex_column">
      <GenericActionBar
        path={
          <div>
            <em>Email Templates</em> → <span>{file.name}</span>
          </div>
        }
        actions={[
          {
            key: "save",
            icon: "save",
            title: isSaving ? "Saving..." : "Save",
            onClick: isSaving ? undefined : handleSaveTemplate
          }
        ]}
        options={{
          save: {
            className: `${isDirty ? "save_glowing" : ""} ${isSaving ? "disabled" : ""}`.trim()
          }
        }}
      />

      <div className="template_form_outer">
        <div className="builder_form">
          <Input label="Subject" name="subject" value={templateData.subject} onChange={handleChange} />
          <Input
            type="checkbox"
            label="HTML Body"
            name="is_html"
            checked={templateData.is_html || false}
            onChange={(e) => setTemplateData({ ...templateData, is_html: e.target.checked })}
          />
          {templateData.is_html ? (
            <CodeEditor
              language="html"
              value={templateData.body}
              handleChange={(code) => setTemplateData({ ...templateData, body: code })}
              height="400px"
              containerClass="w_100"
              enableBacktickTrigger={false}
            />
          ) : (
            <Textarea
              label="Body"
              name="body"
              value={templateData.body}
              onChange={handleChange}
              style={{ height: "300px" }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailTemplateEditor;
